import { useUser } from "@/hooks/useUser";
import { getListPesertaVerifikasi } from "@/services/getData";
import { useQuery } from "@tanstack/react-query";
import { FileSearch } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";

export default function VerifikasiBerkasPage() {
  const { user } = useUser();
  const isVerifikatorUktAll = user?.jenis_user?.includes("verifikator_ukt_all");

  const [searchParams] = useSearchParams();
  const pageParams = searchParams.get("page");
  const rowsPerPageParams = searchParams.get("rowsPerPage");
  const searchQueryParams = searchParams.get("search");
  const statusValidasiParams = searchParams.get("statusValidasi");
  const jenisVerifikatorUktParams =
    searchParams.get("jenisVerifikatorUkt") ||
    (isVerifikatorUktAll ? "all" : "");

  const { data, isPending } = useQuery({
    queryKey: [
      "listPesertaVerifikasi",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
      statusValidasiParams,
      jenisVerifikatorUktParams,
    ],
    queryFn: () =>
      getListPesertaVerifikasi(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string,
        statusValidasiParams as string,
        jenisVerifikatorUktParams as string,
      ),
    enabled: !!user,
    retry: false,
  });

  return (
    <div className="flex flex-col gap-6 w-full pb-10">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 dark:text-slate-100 flex items-center gap-3">
          <div className="p-2.5 bg-primary/10 text-primary rounded-xl">
            <FileSearch className="w-6 h-6" />
          </div>
          Daftar Verifikasi Berkas UKT
        </h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm sm:text-base ml-14">
          Pilih peserta untuk memvalidasi berkas keluarga, aset, dan dokumen
          lainnya.
        </p>
      </div>

      <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200 dark:border-slate-800 overflow-hidden">
        {/* Menghapus early return Skeleton, memindahkan logic loading ke DataTable */}
        <DataTable
          data={data?.data || []}
          paginationData={data}
          columns={columns}
          isLoading={isPending}
        />
      </div>
    </div>
  );
}
